export const WOJEWODZTWA = [
  "dolnośląskie", "kujawsko-pomorskie", "lubelskie", "lubuskie", "łódzkie",
  "małopolskie", "mazowieckie", "opolskie", "podkarpackie", "podlaskie",
  "pomorskie", "śląskie", "świętokrzyskie", "warmińsko-mazurskie",
  "wielkopolskie", "zachodniopomorskie",
];

export const SMS_PROVIDERS = [
  { value: "twilio", label: "Twilio" },
  { value: "smsapi", label: "SMSAPI (PL)" },
  { value: "justsend", label: "JustSend (PL)" },
  { value: "sms-fly", label: "SMS-Fly" },
  { value: "smseagle", label: "SMSEagle (HTTP API / MHD-8100)" },
  { value: "teltonika", label: "Teltonika TRB/RUT (REST)" },
  { value: "yeastar", label: "Yeastar / DBL TG (HTTP)" },
  { value: "goip", label: "DBL GoIP (SMS API)" },
];

export const HW_SMS_PROVIDERS = ["smseagle", "teltonika", "yeastar", "goip"];

export const LICENSE_GROUPS = [
  { title: "Backend (Python)", items: [
    "FastAPI, Pydantic, PyJWT, python-jose, openpyxl, ezdxf, pyproj, pyshp, Stripe, PyYAML — MIT",
    "Starlette, Uvicorn, pandas, numpy, passlib, httpx, Jinja2 — BSD",
    "motor, pymongo, cryptography, bcrypt, boto3, requests, aiohttp, openai, staticmap — Apache 2.0",
    "Pillow — HPND (MIT-like) · pysnmp, reportlab — BSD",
    "paramiko — LGPL 2.1 (bez ryzyka copyleft dla kodu produktu)",
    "pywebpush, py-vapid, http-ece — MPL 2.0 (bez ryzyka copyleft dla kodu produktu)",
  ] },
  { title: "Frontend (React)", items: [
    "React, React Router, Radix UI, framer-motion, recharts, axios, react-query, zod, tailwindcss, sonner — MIT",
    "leaflet — BSD-2 · lucide-react, qrcode.react — ISC",
    "react-leaflet — Hippocratic 2.1 (użycie komercyjne dozwolone)",
  ] },
  { title: "Czcionki", items: [
    "Inter, Manrope, IBM Plex Sans, JetBrains Mono — SIL Open Font License 1.1 (hostowane lokalnie)",
  ] },
  { title: "Mapy / dane", items: [
    "© OpenStreetMap contributors (ODbL — wymóg atrybucji)",
    "Dostawca kafli konfigurowalny (Ustawienia → Mapa) — licencja po stronie operatora",
  ] },
];
